/**
 * Created by mykurisu on 2017/9/15.
 */
import React from 'react'
import {browserHistory} from 'react-router'
import axios from 'axios'
import {shouldLinkToAPP} from '../../utils'
import { toLecture } from '../../utils/connectApp'
import {WKInfiniteScroll} from '../../components/wk'
import '../../styles/record/RecordBuyListItem.css'
import NoList from '../../images/nodiscount.png'
import {NoneItem} from '../../components/details'


class ListenedItem extends React.Component {

    handleLink() {
        const lecture = this.props.item
        if (shouldLinkToAPP()) {
            return toLecture({ id: lecture.id, lectureMode: lecture.lecture_mode })
        }else {
            location.assign(`/lecture/${lecture.id}`)
        }
    }

    render() {
        const lecture = this.props.item
        return (
            <div className="record-page-container" onClick={() => this.handleLink()}>
                <div className="weui-flex weui-padding record-buy-list-item record-listen-list-item">
                    <div className="weui-flex__item flex_3">
                        <div className="record-buy-list-item_img background-image" style={{backgroundImage: `url(${lecture.cover_url})`}}>

                        </div>
                    </div>
                    <div className="weui-flex__item flex_6 padding-left">
                        <p className="record-buy-list-item_title">
                            {lecture.name}
                        </p>
                        <p className="text-minor">
                            {lecture.current_status}
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}


class ListenedList extends React.Component {

    constructor() {
        super();
        this.state = {
            list: null,
            has_more: null,
            next_offset: null,
            loading: false,
        }
    }

    componentDidMount() {
        document.body.scrollTop = 0;
        axios.get('/api/history/listen_record')
            .then(res => {
                if (res.data.code === 0){
                    this.setState({
                        list: res.data.data.records,
                        has_more: res.data.data.has_more,
                        next_offset: res.data.data.next_offset
                    })
                }
            })
    }

    handleLoadMore() {
        this.setState({
            loading: true
        }, () => {
            axios.get('/api/history/listen_record',{
                params: {
                    offset: this.state.next_offset
                }
            })
                .then(res => {
                    if (res.data.code === 0){
                        let newlist = this.state.list.concat(res.data.data.records);
                        this.setState({
                            list: newlist,
                            has_more: res.data.data.has_more,
                            next_offset: res.data.data.next_offset,
                            loading: false
                        })
                    }
                })
        });
    }

    renderContent() {
        if (this.state.list){
            if (this.state.list.length > 0){
                return (
                    <div>
                        {this.state.list.map((item) => <ListenedItem key={item.id} item={item} />)}
                        <WKInfiniteScroll
                            onTouchBottom={() => this.handleLoadMore()} // 到达底部执行的方法
                            isStop={this.state.loading} // 暂停执行onTouchBottom，一般是正在请求接口时触发
                            distance={300} // 距离底部多少px触发
                            isKill={!this.state.has_more || (this.props.tab !== 1)} // 不再监听滚动，一般是传has_more
                        />
                    </div>
                )
            }else {
                return(
                    <div className="record-page-list_no">
                        <NoneItem
                            img="https://static-1253442168.image.myqcloud.com/picture/5915685_3c997315c2944de062355158910c7f1c.jpg"
                            text="暂无听课记录"
                        />
                    </div>
                )
            }
        }else {
            return null
        }
    }

    render() {
        return (
            <div className="record-page-list-outline" style={{paddingTop: '10px'}}>
                {this.renderContent()}
            </div>
        )
    }
}

export default ListenedList


// WEBPACK FOOTER //
// ./src/pages/BoughtPage/ListenedList.js